import { render, staticRenderFns } from "./GenerationHeader.vue?vue&type=template&id=0187ef72&scoped=true&"
import script from "./GenerationHeader.vue?vue&type=script&lang=js&"
export * from "./GenerationHeader.vue?vue&type=script&lang=js&"
import style0 from "./GenerationHeader.vue?vue&type=style&index=0&id=0187ef72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187ef72",
  null
  
)

export default component.exports